__turbopack_context__.v({
  "button": "Button-module__mcUs5a__button",
  "button-loading-pulse": "Button-module__mcUs5a__button-loading-pulse",
  "error": "Button-module__mcUs5a__error",
  "icon": "Button-module__mcUs5a__icon",
  "iconOnly": "Button-module__mcUs5a__iconOnly",
  "info": "Button-module__mcUs5a__info",
  "lg": "Button-module__mcUs5a__lg",
  "loading": "Button-module__mcUs5a__loading",
  "md": "Button-module__mcUs5a__md",
  "onBrand": "Button-module__mcUs5a__onBrand",
  "onDark": "Button-module__mcUs5a__onDark",
  "primary": "Button-module__mcUs5a__primary",
  "rounded": "Button-module__mcUs5a__rounded",
  "secondary": "Button-module__mcUs5a__secondary",
  "sm": "Button-module__mcUs5a__sm",
  "splitMain": "Button-module__mcUs5a__splitMain",
  "splitSecondaryMain": "Button-module__mcUs5a__splitSecondaryMain",
  "splitToggle": "Button-module__mcUs5a__splitToggle",
  "success": "Button-module__mcUs5a__success",
  "tertiary": "Button-module__mcUs5a__tertiary",
  "text": "Button-module__mcUs5a__text",
  "warning": "Button-module__mcUs5a__warning",
});
